export const GET_EMAIL_TEMPLATES = 'GET_EMAIL_TEMPLATES';
export const SET_EMAIL_TEMPLATES = 'SET_EMAIL_TEMPLATES';

export const GET_UPDATE_EMAIL_TEMPLATE = 'GET_UPDATE_EMAIL_TEMPLATE';
export const SET_UPDATE_EMAIL_TEMPLATE = 'SET_UPDATE_EMAIL_TEMPLATE';

export const GET_EMAIL_TEMPLATE_BY_LANG = 'GET_EMAIL_TEMPLATE_BY_LANG';
export const SET_EMAIL_TEMPLATE_BY_LANG = 'SET_EMAIL_TEMPLATE_BY_LANG';
